import {
  Color,
  Mesh,
  MeshPhysicalMaterial,
  PlaneGeometry,
  RepeatWrapping,
  Vector2,
  type Texture,
} from 'three';

export interface TableOptions {
  size?: number;
  feltColor?: number;
  feltSheenColor?: number;
  feltTexture?: Texture | null;
  feltNormal?: Texture | null;
  feltRoughness?: Texture | null;
  textureRepeat?: number;
  normalScale?: number;
}

export function createTable(opts: TableOptions = {}): Mesh {
  const size = opts.size ?? 36;
  const repeat = opts.textureRepeat ?? size / 4;
  const geometry = new PlaneGeometry(size, size);

  for (const tex of [opts.feltTexture, opts.feltNormal, opts.feltRoughness]) {
    if (!tex) continue;
    tex.wrapS = tex.wrapT = RepeatWrapping;
    tex.repeat.set(repeat, repeat);
  }

  const material = new MeshPhysicalMaterial({
    color: opts.feltColor ?? 0x07391f,
    roughness: 1.0,
    metalness: 0,
    sheen: 0.7,
    sheenColor: new Color(opts.feltSheenColor ?? 0x0e6638),
    sheenRoughness: 1.0,
    map: opts.feltTexture ?? null,
    normalMap: opts.feltNormal ?? null,
    roughnessMap: opts.feltRoughness ?? null,
  });

  if (opts.feltNormal) {
    const s = opts.normalScale ?? 1.2;
    material.normalScale = new Vector2(s, s);
  }

  const mesh = new Mesh(geometry, material);
  mesh.rotation.x = -Math.PI / 2;
  mesh.receiveShadow = true;
  return mesh;
}
